(function($) {

  var $grid;

  /**
   * Front cover sizer
   */

   var screen_w;
   var screen_w_old = 0;

  function resize_front_cover() {
    var screen_h = $(window).height();
    var screen_w = $(window).width();
    var cover_h = screen_h - 190;

    if(screen_w == screen_w_old && screen_w_old !== 0) {
      return false; // quit on iPhone scroll resize B.S.
    }
    screen_w_old = screen_w;


    if(cover_h < 400) {
      cover_h = 400;
    }

    var logo_max = 1000;

    var logo_sizer_value;

    if(cover_h > 700) {
      logo_sizer_value = 200;
    } else {
      logo_sizer_value = 125;
    }



    logo_h = cover_h - logo_sizer_value;
    if(logo_h > 1000) {
      logo_h = 1000;
    }
    if(logo_h < 250) {
      logo_h = 250;
    }

    //var top_offset;
    //if(screen_w < 954) {
    //  top_offset = 76;
    //} else {
    //  top_offset = 122;
    //}



    var padding_top = (cover_h - logo_h) / 2 ; // +5
    console.log('cover_H '  + cover_h + ', logo_h ' + logo_h + ', padding_top ' + padding_top);
    $('.hero-logo').height(cover_h);
    $('.hero-logo img').height(logo_h);
    $('.hero-logo img').css('margin-top', padding_top + 'px');


  }

  $(document).ready(function () {
    if( $( ".hero-logo" ).length ) {
      $('.hero-logo img').addClass('fadein');
      resize_front_cover();
    }
  });

  $(window).resize(function () {
    if( $( ".hero-logo" ).length ) {
      resize_front_cover();
    }
  });



  /**
   * Sub-menu
   */
    var dropdown_hover_timeout, active_dropdown;
    $('.menu li a').click(function(e) {
        var href = $(this).attr("href");
        if (href == "#") {
          if($(this).parent().hasClass('hovering-parent')) {
              $(this).parent().removeClass('hovering-parent');
              $('.sub-menu').removeClass('hovering');
          } else {
            $('.menu li').removeClass('hovering-parent');
            $('.sub-menu').removeClass('hovering');
            $(this).parent().addClass('hovering-parent');
            $(this).parent().find('.sub-menu').addClass('hovering');
          }
          return false;
        }
    });

    $('.menu li li').click(function(e) {
      if(e.target.tagName == 'LI') {
        $(this).toggleClass('open');
      }
      e.stopPropagation();
    });

    $('.navigation-toggle').click(function() {
      var $t = $(this);

      // Toggle button class
      $t.toggleClass('active');

      // Toggle target element class
      $($t.attr('data-target'))
        .toggleClass('active');
    });


  $('.menu ul ul a').focusin(function() {
    $(this).closest('ul').addClass('hovering');
  });
  $('.menu ul ul a').focusout(function() {
    $(this).closest('ul').removeClass('hovering');
  });

  /**
   * Sidebar sub-menus
   */
   $('.sub-pages-navigation').find('.page_item_has_children').find('.page_item_has_children').click(function(e) {
      if(e.target.tagName === 'LI') {

        if( $(this).hasClass('current_page_ancestor') ||  $(this).hasClass('current_page_item') ) {
          if(!$(this).hasClass('active') && $(this).hasClass('hide') ) {
            $(this).addClass('hide');
          } else {
            $(this).toggleClass('hide');
            $(this).toggleClass('active');
          }
        } else {
          $(this).toggleClass('active');
        }

        // don't trigger parent(s)
        e.stopPropagation();
      }
   });

  /**
   * Readmore slide
   */

   $(document).ready(function () {
    $(".org-desc p").hide().filter(":first-child").css('display', 'inline');
    $(".org-desc").each(function () {
      if($(this).children('p').length > 1) {
        $(this).addClass('more-than-one');
        $(this).children('.read-more').show();
      }
    });
    $('.org-item .read-more').click(function () {
      $(this).parent().children('p').slideDown();
      $(this).fadeOut();
    });
   });

  /**
   * Packery grid
   */

  $(document).ready(function () {
    $grid = $('.box-list').packery({
      itemSelector: '.box',
      percentPosition: true,
    })
  });

  /**
   * Front page filtering
   */

  $('.front-filter-item').click(function() {

    if($(this).hasClass('filter-condition')) {

      // remove filter-condition
      $(this).removeClass('filter-condition');
      $('.filter-item').removeClass('filtered');

      // show all items
      $('.box-list article').css({'visibility': 'visible', 'display': 'block'}).addClass('box');

    } else {

      // add class to filter condition
      $(this).addClass('filter-condition');

      // remove filtered-condition class to other buttons
      $('.front-filter-item').not(this).removeClass('filter-condition');

      // show all
      $('.box-list article').css({'visibility': 'visible', 'display': 'block'}).addClass('box');

      // remove filter ui changes
      $('.front-filter-item').removeClass('filtered');

      // add filtered class to other buttons
      $('.front-filter-item').not(this).addClass('filtered');

      // filter boxes
      var target = '.' + $(this).attr('data-target');
      $('.box').not(target).css({'visibility': 'hidden', 'display': 'none'}).removeClass("box");

    }

    // re-organize grid
    $grid.packery('layout');

  });

  /**
   * Fixed nav
   */

  $(window).scroll(function() {
    var top = $(document).scrollTop();
    if(top > 300) {
      $('body').addClass('small-menu');
    } else {
      $('body').removeClass('small-menu');
    }
    if(top > 300) {
      $('.thingies').addClass('show');
    }

    var parallax = 125 - (top / 5);
    $('.thingies').css('margin-top', parallax + 'px');

  });

  /**
   * Search overlay
   */

  $('.search-form-top-toggle').click(function () {
    $('.search-overlay').fadeIn();
    $('#search-overlay-input').focus();
  });

  $('#search-overlay-x').click(function () {
    $('.search-overlay').fadeOut(150);
  });

  /**
   * Navigation overlay
   */

  $('.menu-toggle').click(function () {
    $('.mobile-menu').fadeToggle();
  });

  $('#mobile-menu-x').click(function () {
    $('.mobile-menu').fadeOut(150);
  });

  /**
   * ACF Map
   */

  function new_map( $el ) {


    var $markers = $el.find('.marker');
    var args = {
      zoom    : 16,
      center    : new google.maps.LatLng(0, 0),
      mapTypeId : google.maps.MapTypeId.ROADMAP,
      scrollwheel : false,
    };


    var map = new google.maps.Map( $el[0], args);

    map.markers = [];

    $markers.each(function(){
      add_marker( $(this), map );
    });

    center_map( map );
    return map;
  }

  function add_marker( $marker, map ) {

    var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );
    var marker = new google.maps.Marker({
      position  : latlng,
      map     : map,
      icon: {
        path: google.maps.SymbolPath.CIRCLE,
        scale: 7,
        fillColor: '#ffffff',
        strokeColor: '#224499',
        fillOpacity: 1
      }
    });

    map.markers.push( marker );

    if( $marker.html() ) {
      var infowindow = new google.maps.InfoWindow({
        content   : $marker.html()
      });
      google.maps.event.addListener(marker, 'click', function() {
        infowindow.open( map, marker );
      });
    }
  }

  function center_map( map ) {
    var bounds = new google.maps.LatLngBounds();
    $.each( map.markers, function( i, marker ){
      var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );
      bounds.extend( latlng );
    });

    if( map.markers.length == 1 ) {
      map.setCenter( bounds.getCenter() );
      map.setZoom( 10 );
    }
    else {
      map.fitBounds( bounds );
    }
  }

  var map = null;
  $(document).ready(function(){
    $('.acf-map').each(function(){
      map = new_map( $(this) );
    });
  });



})(jQuery);
